module.exports = __webpack_public_path__ + "static/img/77010E_2_R_20190709_fit.1ed8ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77010E_2_R_20190709_fit.png
// module id = m4kx
// module chunks = 0